export const MODAL_ROOT = 'line-spacing-modal';
export const TEXT_BUTTON_LINE_SPACING = 'text-button-line-spacing';
export const PREDEFINED_SPACING_OPTION = 'predefined-spacing-option';
export const SPACING_SELECTOR_BUTTON = 'spacing-selector-button';
export const LINE_SPACING_INPUT = 'line-spacing-input';
export const BEFORE_PARAGRAPH_INPUT = 'before-paragraph-input';
export const AFTER_PARAGRAPH_INPUT = 'after-paragraph-input';
